import { useState, forwardRef, useEffect, useCallback } from "react";
import { Tooltip } from 'react-tooltip';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller, useFieldArray  } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import DatosCabezaFamilia from "../DatosCabezaFamilia";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from "../Componentes/MenuCaracterizacion";
import { BotonBorrar } from "./../../Utils/BotonBorrar.jsx";
import { useAuth } from '../../../Auth/AuthContext';
import PropTypes from 'prop-types';
import { FaCalendar } from "react-icons/fa";

registerLocale('es', es);
setDefaultLocale('es');
const CustomInputs = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input 
                value={value} 
                readOnly 
                className='widthCalendar' 
                style={{ pointerEvents: 'none',
                background: '#fff',
                border: '1px solid #ced4da',
                padding: '6px 8px',
                borderRadius: 4,
                minWidth: 140,
                marginRight: 8, 
                }}
            />
            <FaCalendar size={20} color="black"/>
        </button>
        ));

function borrando(row, Borraratencion){
    return (
        <div>
            <BotonBorrar Borrar={Borraratencion} row={row} />
        </div>
    );
}
export default function Remisiones(){
    const {token , rol, user, sedeActual} = useAuth();
    const [cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const { control, handleSubmit, register, setValue, getValues, reset, formState: { errors }} = useForm();
    const [entidades, setEntidades] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const { append, remove } = useFieldArray({
        control,
        name: 'remisionesfields'
      });
    const [swalProps, setSwalProps] = useState({});
    const [cabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const onSubmit = async (data) => {
        if(integrantes.find((item) => item.per_idpersona === data.idPersona).per_fallecido === 'SI'){
            Mensaje('Registrar atencion', "No se puede registrar atencion a un integrante fallecido");
            return;
        }
        const nombreayuda = ayudas.find((item) => item.id === data.idayuda).ayuAyuda;
        const nombreentidad = entidades.find((item) => item.id === data.entidad).entEntidad;
        append({
            idayuda: data.idayuda, 
            cantidad: data.cantidad, 
            valor : data.valorunitario,
            observaciones: data.observaciones,
            fecha: data.fecha, 
            identidad: data.entidad, 
            ayuda: nombreayuda, 
            entidad : nombreentidad,
            idPersona: data.idPersona
        });
        ResetForm()
    };
    

    CustomInputs.propTypes = {
        value: PropTypes.string,
        onClick: PropTypes.func
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => borrando(row, Borraratencion),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Integrante', selector: row => row.idPersona, sortable: true, width: '15%' },
        { name: 'Ayuda', selector: row => row.ayuda, sortable: true, width:'25%' },
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '15%' },
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
    function Borraratencion (row){
        remove(getValues('remisionesfields').indexOf(row));
    };
    const GuardarRemisiones = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/remisiones/remisionarpersona';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data));
                ResetForm(true);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }

      };
    const ResetForm = useCallback((cleanList) => {
        const fechahoy = new Date();
        fechahoy.setHours(fechahoy.getHours() - 5);
        reset((prevValues) => ({
            ...prevValues,
            sede: sedeActual,
            usrId: user,
            idpersona: idCabezaFamilia,
            idayuda: "",
            entidad: 1,
            fecha: fechahoy,
            cantidad: '1',
            observaciones: "",
            remisionesfields: cleanList ? [] : prevValues.remisionesfields
        }))
    }, [sedeActual, user, idCabezaFamilia, reset]);

    const fetchData = useCallback(async () => {
        const url = '/remisiones/crearformularioremision';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            if (Array.isArray(result.entidades)) {
                setEntidades(result.entidades);
            } else {
                console.error('Expected entidades to be an array');
            }
            if (result.sedes && Array.isArray(result.sedes)) {
                setSedes(result.sedes);
            } else {
                console.error('Invalid sedes data:', result.sedes);
            }
            if (Array.isArray(result.integrantesdto)) {
                setIntegrantes(result.integrantesdto);
            } else {
                console.error('Expected integrantesdto to be an array');
            }
            if (Array.isArray(result.ayudas)) {
                setAyudas(result.ayudas);
            } else {
                console.error('Expected ayudas to be an array');
            }
            ResetForm(true);
            setValue('usrId', user);
            setValue('cabIdcabezafamilia', idCabezaFamilia);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
    }, [idCabezaFamilia, rol, token, user, ResetForm, setValue]);
    useEffect(() => {
        if (sedes.length > 0 && sedeActual) {
            setValue('sede', sedeActual);
        }
    }, [sedes, sedeActual, setValue]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registrar remisiones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={"/"} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Remisiones</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <DatosCabezaFamilia datos={cabezaFamiliaDatos} />
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="entidad">Entidad</label>
                                            <select id="entidad" {...register('entidad', { required: true })} className='form-control'>
                                                {entidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.id} {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="idayuda">Remisi&oacute;n</label>
                                            <select id="idayuda" {...register('idayuda', { required: true })} className='form-control'>
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ayuAyuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idayuda && <p style={{color: 'red'}}>Seleccione tipo ayuda</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="idPersona">Integrante</label>
                                            <select id="idPersona" {...register('idPersona', { required: true })} className='form-control'>
                                                <option value="">Seleccionar</option>
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre} {option.per_fallecido === 'SI' ? '(Fallecido)' : ''}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idPersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="fecha">Fecha:</label>
                                            <Controller
                                                id="fecha"
                                                control={control}
                                                name="fecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInputs />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de entrega</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='sede'>Sede:</label>
                                            <select id='sede' {...register('sede', { required: true })} className='form-control'>
                                                {sedes.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.sedNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccione sede</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea className='form-control' rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Agregar</button>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-body table-responsive p-0">
                                        <DataTable
                                            title="Remisiones"
                                            columns={columns}
                                            data={getValues('remisionesfields')}    
                                            progressPending={cargando}
                                            pagination
                                            noDataComponent="No hay datos para mostrar"
                                        /> 
                                    </div>
                                </div>
                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                                <button type="button" onClick={GuardarRemisiones} className="btn btn-primary">Guardar</button>
                                
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}